var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-app"},[_c('div',{staticClass:"open"},[_c('p',{staticClass:"btn",attrs:{"id":"btn"}},[_vm._v("打开APP")])])])}]

export { render, staticRenderFns }